import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cancel-test-dialog',
  templateUrl: './cancel-test-dialog.component.html',
  styleUrls: ['./cancel-test-dialog.component.scss'],
  standalone: false,
})
export class CancelTestDialogComponent {
  reason = '';

  constructor(public dialogRef: MatDialogRef<CancelTestDialogComponent>) {}

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close(this.reason);
  }
}
